import { InputTextarea } from 'primereact/inputtextarea';
import React, {  useState } from 'react';

const RenderRespostaQuestaoAberta = ({questao, capturarRespostaQuestaoAberta, isQuestaoAberta, state}) => {
    const MAX_CARACTERES = 1000;
    const [caracteresRestantes, setCaracteresRestantes] = useState(MAX_CARACTERES);
    
    if (isQuestaoAberta(questao)) {
        return (
            <div>
                <InputTextarea id={questao.id} autoResize rows={5} cols={30} value={state[questao.id]} maxLength={MAX_CARACTERES}
                    onChange={(e) => {
                        const valorAtual = e.target.value;

                        capturarRespostaQuestaoAberta(questao.id, valorAtual);
                        setCaracteresRestantes(MAX_CARACTERES - valorAtual.length);
                    }} />
                <div className="textcounter" >
                {`${caracteresRestantes} de ${MAX_CARACTERES} caracteres restantes`}
                </div> 
            </div>
        );
    }else{
        return null;
    }
}
export default RenderRespostaQuestaoAberta